const whiteListCountries = [
  "united states",
  "canada",
  "united kingdom",
  "isle of man",
  "france",
  "frankreich",
  "francia",
  "germany",
  "deutschland",
  "germania",
  "alemania",
  "allemagne",
  "italy",
  "italia",
  "italie",
  "italien",
  "australia",
  "new zealand",
];

function getGeolocation() {
  if (geolocation === "Estados Unidos") {
    return "united states";
  }
  return geolocation.toLowerCase();
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  if (elementToFocus == null) {
    elementToFocus = container;
  }
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input =
      this.querySelector('input[id="Quantity-upsell-popup"]') || this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.otherQuantityInputs = Array.from(document.querySelectorAll("quantity-input")).filter(
      (qtyInput) => !Object.is(qtyInput, this)
    );

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );

    // Update button states on input change for cart items
    if (this.closest('.cart-item')) {
      this.input.addEventListener('input', () => this.updateButtonStates());
      this.updateButtonStates(); // Initial state
    }
  }

  updateButtonStates() {
    const minusButton = this.querySelector('button[name="minus"]');
    const currentValue = parseInt(this.input.value) || 1;

    if (minusButton && this.closest('.cart-item')) {
      if (currentValue <= 1) {
        minusButton.style.opacity = '0.5';
        minusButton.style.cursor = 'not-allowed';
        minusButton.title = 'Use remove button to delete item';
      } else {
        minusButton.style.opacity = '';
        minusButton.style.cursor = '';
        minusButton.title = '';
      }
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    const variantId = this.closest("form")
      ?.querySelector("input[data-productid]")
      ?.getAttribute("value");

    const matchedEarlyAccessObject = earlyAccessData.find(
      (item) => item.earlyAccessVariantId == variantId
    );

    if (qtyLimitEnabled) {
      if (
        matchedEarlyAccessObject &&
        matchedEarlyAccessObject.earlyAccessProductQtyLimit > 0 &&
        previousValue == matchedEarlyAccessObject.earlyAccessProductQtyLimit - 1
      ) {
        this.querySelector(
          `[productid = "${matchedEarlyAccessObject.earlyAccessProductId}"]`
        ).setAttribute("disable", true);
      }
      if (
        matchedEarlyAccessObject &&
        matchedEarlyAccessObject.earlyAccessProductQtyLimit > 0 &&
        previousValue >= matchedEarlyAccessObject.earlyAccessProductQtyLimit
      ) {
        if (event.target.name === "minus") {
          this.querySelector(
            `[productid = "${matchedEarlyAccessObject.earlyAccessProductId}"]`
          ).removeAttribute("disable");
          this.input.stepDown();
        }
        return;
      }
    } else {
    }

    if (event.target.name === "plus") {
      this.input.stepUp();
    } else {
      // For minus button, check if we're in a cart item
      const isCartItem = this.closest('.cart-item');
      if (isCartItem && parseInt(this.input.value) <= 1) {
        // Don't allow going below 1 in cart - user should remove item instead
        // Add visual feedback that button is at minimum
        event.target.style.opacity = '0.5';
        setTimeout(() => {
          event.target.style.opacity = '';
        }, 200);
        return;
      }
      this.input.stepDown();
    }
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    // Update button states for cart items
    if (this.closest('.cart-item')) {
      this.updateButtonStates();
    }

    // Only sync quantities for product forms, not cart items
    const isCartItem = this.closest('.cart-item');
    if (event.target.id === "" && this.otherQuantityInputs && this.otherQuantityInputs.length > 0 && !isCartItem) {
      this.syncQuantity();
    }
  }

  syncQuantity() {
    this.otherQuantityInputs.forEach((qtyInput) => {
      qtyInput.input.value = this.input.value;
    });
  }
}

customElements.define("quantity-input", QuantityInput);

window.debounce ||= function(fn, wait) {
  let t;
  return function(...args) {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};

const serializeForm = (form, qty) => {
  const obj = {};
  const formData = new FormData(form);

  if (!formData.get("quantity")) {
    formData.set("quantity", qty);
  }

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options["hideElement"] || province_domid);

  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector("button"));

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    // document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      document.querySelector("body").style.overflow = "visible";

      const widget = document.querySelector(".weglot-container.wg-default");
      if (widget) {
        widget.style.display = "block";
      }

      const stickyAtc = document.querySelector("sticky-atc.stickyactive");
      if (stickyAtc) {
        stickyAtc.style.visibility = "visible";
      }

      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle.querySelector("summary").setAttribute("aria-expanded", false);
      // document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    this.drawerOverlay = this.querySelector(".menu-drawer__overlay");
    this.drawerOverlay.addEventListener("click", this.onOverlayClick.bind(this));
  }

  onOverlayClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    if (isOpen) event.preventDefault();
    isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom")
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
      document.querySelector("body").style.overflow = "hidden";

      const widget = document.querySelector(".weglot-container.wg-default");
      if (widget) {
        widget.style.display = "none";
      }

      const stickyAtc = document.querySelector("sticky-atc.stickyactive");
      if (stickyAtc) {
        stickyAtc.style.visibility = "hidden";
      }
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    // document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define("header-drawer", HeaderDrawer);

class PopupModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.popupOverlay = this.querySelector(".popup--overlay");
    this.popupClose = this.querySelector("#popupClose");

    [this.popupOverlay, this.popupClose].forEach((elm) =>
      elm.addEventListener("click", this.closePopup.bind(this))
    );
  }

  openPopup() {
    this.classList.add("opened");
  }
  closePopup() {
    this.classList.remove("opened");
  }
}

customElements.define("popup-modal", PopupModal);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this));
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (event.pointerType === "mouse" && !event.target.closest("deferred-media, product-model"))
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));

    if (window.innerWidth < 600) {
      setTimeout(() => {
        poster.click();
      }, 2000);
    }
  }

  loadContent() {
    const title = document.querySelector(".video-section .title");

    if (title) {
      document.querySelector(".video-section .title").style.display = "none";
    }

    // window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));

      this.setAttribute("loaded", true);
      this.appendChild(content.querySelector("video, model-viewer, iframe")).focus();

      if (window.innerWidth < 600 && document.querySelector("#existing-iframe-youtube")) {
        var player;
        player = new YT.Player("existing-iframe-youtube", {
          events: {
            onReady: onPlayerReady,
          },
        });
        function onPlayerReady(event) {
          event.target.mute();
          event.target.playVideo();
        }
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class CustomMediaPlayer extends DeferredMedia {
  constructor() {
    super();
  }
}

customElements.define("custom-media-player", CustomMediaPlayer);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("ul");
    this.sliderItems = this.querySelectorAll("li");
    this.pageCount = this.querySelector(".slider-counter--current");
    this.pageTotal = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.dots = this.querySelectorAll(".slider_control");
    this.currentDot = this.querySelector(".slider_control.active");

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.slider.addEventListener("touchstart", this.touchStart.bind(this));
    this.slider.addEventListener("touchmove", this.touchMove.bind(this));
    this.slider.addEventListener("touchend", this.touchEnd.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
    this.dots.forEach((dot) => {
      dot.addEventListener("click", this.onDotClick.bind(this));
    });
  }

  reInit() {
    this.sliderItems = this.querySelectorAll("li");
    this.slider.scrollTo({
      left: 0,
    });
    this.initPages();
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.sliderWidth = sliderItemsToShow[0].clientWidth;
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  touchStart(e) {
    let targetElement = e.target;
    while (targetElement != null) {
      if (targetElement.matches("button.button")) {
        return;
      }
      targetElement = targetElement.parentElement;
    }

    this.touchStartX = e.touches[0].clientX;
  }

  touchEnd(e) {
    let targetElement = e.target;
    while (targetElement != null) {
      if (targetElement.matches("button.button")) {
        return;
      }
      targetElement = targetElement.parentElement;
    }

    let currentDotIndex = parseInt(this.currentDot.dataset.index);

    this.currentDot.classList.remove("active");

    const touchEndX = e.changedTouches[0].clientX;
    this.swipeDistance = touchEndX - this.touchStartX;

    const minSwipeDistance = 0.35 * this.sliderWidth;

    let slideScrollPosition;

    if (currentDotIndex == 0) {
      slideScrollPosition = 0;
    } else {
      slideScrollPosition = currentDotIndex * this.sliderWidth + 30 * currentDotIndex;
    }

    let selectDot = this.querySelector(`.dots .slider_control[data-index="${currentDotIndex}"]`);

    if (this.swipeDistance < minSwipeDistance && currentDotIndex + 1 <= this.totalPages) {
      currentDotIndex++;
    } else if (this.swipeDistance > -minSwipeDistance && currentDotIndex - 1 >= 0) {
      currentDotIndex--;
    }

    slideScrollPosition = currentDotIndex * this.sliderWidth + 30 * currentDotIndex;
    selectDot = this.querySelector(`.dots .slider_control[data-index="${currentDotIndex}"]`);

    if (selectDot) {
      this.slider.scrollTo({
        left: slideScrollPosition,
        behavior: "smooth",
      });

      this.currentDot = selectDot;
      this.currentDot.classList.add("active");
    }
  }

  touchMove() {}
  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute("disabled", true);
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute("disabled", true);
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onDotClick(event) {
    event.preventDefault();
    if (event.currentTarget == this.currentDot) return;

    const slideScrollPosition =
      (this.sliderLastItem.clientWidth + 30) * event.currentTarget.dataset.index;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
    this.currentDot.classList.remove("active");
    this.currentDot = event.currentTarget;
    this.currentDot.classList.add("active");
  }

  onButtonClick(event) {
    console.log("onButtonClick");
    event.preventDefault();
    const slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + this.sliderLastItem.clientWidth + 30
        : this.slider.scrollLeft - this.sliderLastItem.clientWidth - 30;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });

    if (!this.currentDot) return;

    const currentDotIndex = parseInt(this.currentDot.dataset.index);
    const newDotIndex =
      event.currentTarget.name === "next" ? currentDotIndex + 1 : currentDotIndex - 1;

    this.currentDot.classList.remove("active");
    this.currentDot = this.querySelector(`.dots .slider_control[data-index = "${newDotIndex}"]`);
    this.currentDot.classList.add("active");
  }
}

customElements.define("slider-component", SliderComponent);

class ProductDesc extends HTMLElement {
  constructor() {
    super();

    this.wrapVideos();
    this.popupSubscription();
    this.tabs = this.querySelectorAll(".tab");
  }

  popupSubscription() {
    const target = this.querySelector("[data-subscription]");
    const popupContainer = document.querySelector("pop-up");
    target
      ? target.addEventListener("click", (e) => {
          e.preventDefault();
          this.updatePopupContent();
          popupContainer.classList.add("show");
        })
      : "";
  }

  updatePopupContent() {
    const popupContent = document.querySelector("pop-up .popup-content");
    const html = `
		<h2 class="modal-sub-header text-center">DO YOU WANT TO…</h2>
		<div class="btn-lists">
          <a class="button modal-btn1" href="/account/login">
              MANAGE A CURRENT SUBSCRIPTION
          </a>
          <a class="button modal-btn2" href="/a/account/custom-tools/dynamic-box?product=7878623756487">
              BUILD A NEW SUBSCRIPTION
          </a>
		</div>
	`;
    popupContent.innerHTML = html;
  }

  wrapVideos() {
    const iframes = this.querySelectorAll("iframe[src]");
    iframes.forEach((iframe) => {
      const vidWrapper = document.createElement("div");
      vidWrapper.setAttribute("class", "desc__video-wrapper");
      iframe.parentNode.insertBefore(vidWrapper, iframe);
      vidWrapper.appendChild(iframe);

      const videoWidth = parseFloat(iframe.getAttribute("width"));
      const videoHeight = parseFloat(iframe.getAttribute("height"));
      const videoRatio =
        !isNaN(videoWidth) && !isNaN(videoHeight) ? (videoHeight / videoWidth) * 100 : 0;
      vidWrapper.style.paddingBottom = videoRatio + "%";
    });
  }
}

customElements.define("product-desc", ProductDesc);

class VariantSelects extends HTMLElement {
  constructor() {
    super();

    this.prodId = this.dataset.productId;
    this.oosCountries = this.closest("product-form").querySelector(`#oosCountries-${this.prodId}`);
    this.otherVariantSelects = Array.from(document.querySelectorAll("variant-selects")).filter(
      (selector) => !Object.is(selector, this)
    );
  }

  async connectedCallback() {
    const oosCountries = JSON.parse(this.oosCountries.innerHTML)["oos_countries"];
    const currentCountry = getGeolocation();
    if (oosCountries && !oosCountries.includes(currentCountry))
      this.addEventListener("change", this.onVariantChange);

    // Add an event to fire the onVariantChange function for ticket 11737. Some products, like Lemon Drop Capsules, link to an unavailable variant when directed from Google Search.
    this.onVariantChange();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();

    if (this.getAttribute("current-template")?.includes("early-access") && !enableAtc) {
      // this.toggleAddButton(false, "", false);
    } else {
      // this.toggleAddButton(true, "", false);
    }
    // this.updatePickupAvailability();

    if (this.otherVariantSelects && this.otherVariantSelects.length > 0) {
      this.syncVariantSelects();
    }

    // If this.currentVariant exists, store it in sessionStorage
    if (this.currentVariant) {
      sessionStorage.setItem("storedCurrentVariant", JSON.stringify(this.currentVariant));
    } else {
      // If this.currentVariant is undefined and a stored variant exists in sessionStorage, retrieve it
      const storedVariant = sessionStorage.getItem("storedCurrentVariant");
      if (storedVariant) {
        this.currentVariant = JSON.parse(storedVariant);
        console.log("Loaded currentVariant from sessionStorage:", this.currentVariant);
      } else {
        this.toggleAddButton(true, "", true);
        this.setUnavailable();
        return; // Return early to avoid further operations if no variant is found
      }
    }

    const currentScrollY = window.scrollY;
    const currentVariantOption = this.currentVariant.option1;
    const stickyAtcForm = document.querySelector("sticky-atc product-form variant-radios");
    const variantInputs = stickyAtcForm?.querySelectorAll('input[type="radio"]');

    variantInputs?.forEach((input) => {
      if (input.value === currentVariantOption) {
        const label = stickyAtcForm?.querySelector(`label[for="${input.id}"]`);
        if (label) {
          label.style.border = "2px solid black";
          label.style.padding = "5px";
        }
      } else {
        const label = stickyAtcForm?.querySelector(`label[for="${input.id}"]`);
        if (label) {
          label.style.border = "";
        }
      }
    });

    window.scrollTo(0, currentScrollY);

    console.log("stickyAtcForm", stickyAtcForm);

    // Continue with the existing logic if this.currentVariant exists
    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll("select"), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const swiper = document.querySelector(
      ".product-main-slider, .pdp-redesign-product-main-slider"
    ).swiper;
    console.log(swiper, this.currentVariant.featured_media.position - 1);

    swiper?.slideTo(this.currentVariant.featured_media.position - 1, 1000);

    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector("sticky-header");
    if (this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
    }
    window.setTimeout(() => {
      parent.querySelector("li.product__media-item").scrollIntoView({ behavior: "smooth" });
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `form[data-type="add-to-cart-form"], #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));

      const customAvailability = productForm.querySelector('input[name="custom-availability"]');
      if (customAvailability) {
        customAvailability.value = this.currentVariant.available ? "true" : "false";
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  async renderProductInfo() {
    try {
      const response = await fetch(
        `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
      );
      const responseText = await response.text();

      const id = `price-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const destination = document.getElementById(id);
      const source = html.getElementById(id);

      if (source && destination) {
        destination.innerHTML = source.innerHTML;
      }

      const price = document.getElementById(`price-${this.dataset.section}`);

      if (price) {
        price.classList.remove("visibility-hidden");
      }

      this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
    } catch (error) {
      console.error("Error rendering product info:", error);
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForms = document.querySelectorAll(`form[data-type="add-to-cart-form"]`);
    if (productForms && productForms.length > 0) {
      productForms.forEach((productForm) => {
        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute("disabled", true);
          if (text) addButton.textContent = text;
        } else {
          const matchedEarlyAccessObject = earlyAccessData.find(
            (item) => item.earlyAccessProductId == this.prodId
          );

          if (this.prodId == matchedEarlyAccessObject?.earlyAccessProductId) {
            if (matchedEarlyAccessObject?.isAdventCalendar) {
              loggedIn = true;
              enableAtc = true;
            }
            if (loggedIn) {
              if (enableAtc) {
                const existingQtyHelpMessage = document.querySelector(
                  ".gating-product-qty-limit-message"
                );

                if (existingQtyHelpMessage) {
                  existingQtyHelpMessage.remove();
                }
                addButton.removeAttribute("disabled");
                addButton.textContent = window.variantStrings.addToCart;
              } else {
                const existingHelpMessage = document.querySelector(".gating-product-help-message");

                if (!existingHelpMessage) {
                  addButton.textContent = window.variantStrings.addToCart;

                  const helpMessage = document.createElement("div");
                  helpMessage.classList.add("gating-product-help-message");
                  helpMessage.innerHTML = `${matchedEarlyAccessObject.earlyAccessProductTitle} are currently only available to subscribers, general sale will open at a later date.`;

                  addButton.parentNode.insertBefore(helpMessage, addButton);
                }
              }
            } else {
              const existingHelpMessage = document.querySelector(".gating-product-help-message");

              if (!existingHelpMessage) {
                addButton.textContent = window.variantStrings.addToCart;

                const helpMessage = document.createElement("div");
                helpMessage.classList.add("gating-product-help-message");
                helpMessage.innerHTML = `Please <span onclick="event.preventDefault(); window.location.href='/account/login';">log in</span>. This product is for subscribers only.`;
                addButton.parentNode.insertBefore(helpMessage, addButton);
              }
            }
          } else {
            addButton.removeAttribute("disabled");
            addButton.textContent = window.variantStrings.addToCart;

            const marketHandle = this.getAttribute("market-handle");

            if (marketHandle === "australia-nz") {
              addButton.setAttribute("disabled", true);
              addButton.textContent = "Coming Soon";
              addButton.style.opacity = "1";
            }
          }
        }

        if (!modifyClass) return;
      });
    }
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const productId = button.getAttribute("data-productid");

    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;

    if (productId === "4787836649521") {
      addButton.textContent = "Please select lid type";
    } else if (
      productId === "7078046204103" ||
      productId === "7078046433479" ||
      productId === "7078045024455"
    ) {
      addButton.textContent = "Select Machine";
    } else {
      addButton.textContent = "ADD TO CART";
      // addButton.textContent = window.variantStrings.unavailable;
    }
    // if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  syncVariantSelects() {
    this.otherVariantSelects.forEach((varSelects) => {
      varSelects.querySelectorAll("select").forEach((select, index) => {
        select.value = this.querySelector(`#Option-${this.dataset.section}-${index}`).value;
      });
    });
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.hideUnavailableVariants =
      this.getAttribute("data-hide-unavailable-variants") == "true" ? true : false;

    if (this.hideUnavailableVariants) {
      const variants = this.getVariantData();
      this.querySelectorAll('input[type=radio]:not([name="Select your model"]) + label').forEach(
        (label) => {
          label.classList.add("label-hidden");
        }
      );
      const initOption1 = this.getAttribute("selected-or-first-available-variant-option-1");

      if (initOption1) {
        const typeVariants = variants.filter(
          (v) => v.option1 == initOption1 || v.option2 == initOption1 || v.option3 == initOption1
        );

        typeVariants.forEach((v) => {
          const optionsNotType = v.options.filter((option) => option != initOption1);
          optionsNotType.forEach((option) => {
            document
              .querySelectorAll(`input[type=radio][value="${option}"] + label`)
              .forEach((label) => {
                label.classList.remove("label-hidden");
              });
          });
        });
      }

      this.querySelectorAll('input[type=radio][name="Select your model"]').forEach((i) => {
        i.addEventListener("change", (e) => {
          this.querySelectorAll(
            'input[type=radio]:not([name="Select your model"]) + label'
          ).forEach((label) => {
            label.classList.add("label-hidden");
          });
          const inputValue = e.target.value;

          const typeVariants = variants.filter(
            (v) => v.option1 == inputValue || v.option2 == inputValue || v.option3 == inputValue
          );

          typeVariants.forEach((v) => {
            const optionsNotType = v.options.filter((option) => option != inputValue);
            optionsNotType.forEach((option) => {
              document
                .querySelectorAll(`input[type=radio][value="${option}"] + label`)
                .forEach((label) => {
                  label.classList.remove("label-hidden");
                });
            });
          });
        });
      });
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));

    if (this.closest("sticky-atc")) {
      const radioButtons = this.closest("sticky-atc").querySelectorAll(
        'variant-radios .product-form__input input[type="radio"]'
      );

      const secondLabel = this.closest("sticky-atc").querySelectorAll("legend.form__label")[1];
      console.log(secondLabel);

      radioButtons.forEach(function (radioButton) {
        radioButton.addEventListener("change", function () {
          // Remove the margin from all parent elements first to reset
          // secondLabel.style.display = "block";
          radioButtons.forEach(function (btn) {
            const parentElement = btn.closest(".product-form__input");
            if (parentElement) {
              parentElement.style.marginBottom = "1rem";
            }
          });

          // Check if the current radio button is checked
          if (radioButton.checked) {
            const parentElement = radioButton.closest(".product-form__input");
            if (parentElement) {
              // Add margin-bottom to the parent element
              parentElement.style.marginBottom = "1rem";
            }
          }
        });
      });
    }

    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked)?.value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

document.addEventListener("DOMContentLoaded", (event) => {
  document.querySelectorAll(".checkbox-link").forEach((item) => {
    item.addEventListener("click", function (e) {
      e.preventDefault();
      this.classList.toggle("checked");
    });
  });

  function manageMenuToggle() {
    if (window.innerWidth < 768) {
      document.querySelectorAll(".menu-drawer__main-list details").forEach((detail) => {
        detail.addEventListener("toggle", function () {
          if (this.open) {
            document
              .querySelectorAll(".menu-drawer__main-list details[open]")
              .forEach((openDetail) => {
                if (openDetail !== this) {
                  openDetail.removeAttribute("open");
                }
              });
          }
        });
      });
    } else {
      document.querySelectorAll(".menu-drawer__main-list details").forEach((detail) => {
        detail.removeEventListener("toggle", manageMenuToggle);
      });
    }
  }

  manageMenuToggle();

  window.addEventListener("resize", manageMenuToggle);
});

/**
 * Early Access Quantity Limit Handler
 * Disables + button when quantity limit is reached
 */
document.addEventListener('DOMContentLoaded', () => {
  function checkEarlyAccessLimits() {
    const plusButtons = document.querySelectorAll('.cart-quantity-plus[data-is-early-access="true"]');

    plusButtons.forEach((button) => {
      const limit = parseInt(button.dataset.earlyAccessLimit);
      const currentQty = parseInt(button.dataset.currentQty);

      if (limit > 0 && currentQty >= limit) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('title', `Maximum quantity of ${limit} reached`);
      } else {
        button.disabled = false;
        button.setAttribute('aria-disabled', 'false');
        button.removeAttribute('title');
      }
    });
  }

  // Check limits on page load
  checkEarlyAccessLimits();

  // Re-check when cart state changes (handled by CartStateManager)
  if (window.cartStateManager) {
    window.cartStateManager.subscribe(() => {
      // Wait for DOM to update
      setTimeout(() => {
        checkEarlyAccessLimits();
      }, 100);
    });
  }
});

/**
 * Rebuy Widget Integration with CartStateManager
 * Intercepts Rebuy add-to-cart events and routes through CartStateManager
 */
document.addEventListener('DOMContentLoaded', () => {
  // Listen for Rebuy add-to-cart events
  document.addEventListener('rebuy:cart.change', async (event) => {
    // Rebuy has made a cart change, sync with CartStateManager
    if (window.cartStateManager) {
      try {
        // Fetch fresh cart state to sync
        const freshState = await window.cartStateManager.fetchCart();
        window.cartStateManager.setState(freshState);
      } catch (error) {
        console.error('Error syncing Rebuy cart change with CartStateManager:', error);
      }
    }
  });

  // Alternative: Intercept Rebuy button clicks before they execute
  // This requires MutationObserver to catch dynamically added Rebuy buttons
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // Element node
          // Find Rebuy add-to-cart buttons
          const rebuyButtons = node.querySelectorAll ?
            node.querySelectorAll('[data-rebuy-add-to-cart], .rebuy-button--add-to-cart') : [];

          rebuyButtons.forEach((button) => {
            // Only add listener once
            if (!button.dataset.cartManagerIntegrated) {
              button.dataset.cartManagerIntegrated = 'true';

              button.addEventListener('click', async (e) => {
                // Let Rebuy handle the cart add, then sync state
                setTimeout(async () => {
                  if (window.cartStateManager) {
                    try {
                      const freshState = await window.cartStateManager.fetchCart();
                      window.cartStateManager.setState(freshState);
                    } catch (error) {
                      console.error('Error syncing after Rebuy cart add:', error);
                    }
                  }
                }, 500); // Wait for Rebuy to complete
              });
            }
          });
        }
      });
    });
  });

  // Start observing the document for Rebuy widget insertions
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
